// src/components/providers/multi-arm-bandit-context-provider.tsx
import React from "react";
var DEFAULT_MULTI_ARM_BANDIT_TRACK_CONTEXT = {
    multiArmBanditTrack: void 0
};
var MultiArmBanditContext = React.createContext(DEFAULT_MULTI_ARM_BANDIT_TRACK_CONTEXT);
var useMultiArmBanditContext = function() {
    return React.useContext(MultiArmBanditContext);
};
var MultiArmBanditContextProvider = function(param) {
    var multiArmBanditTrackContext = param.multiArmBanditTrackContext, children = param.children;
    return /* @__PURE__ */ React.createElement(MultiArmBanditContext.Provider, {
        value: multiArmBanditTrackContext
    }, children);
};
MultiArmBanditContextProvider.displayName = "MultiArmBanditContextProvider";
export { MultiArmBanditContextProvider, useMultiArmBanditContext };
//# sourceMappingURL=index.js.map